import matchSorter from 'match-sorter';
import { Option } from '../../../libs/types';

export const filterItems = (options: Option[], filter: string | null) =>
  filter
    ? matchSorter(options, filter, {
        keys: ['label']
      })
    : options;
